import {map} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {StorageService} from '../../storage/storage.service';
import {TranslateService} from '@ngx-translate/core';
import {HttpService} from '../http-service.service';
import {ApiConst} from '../api-const';
import {Observable, Subject} from 'rxjs';
import {AddressLine} from '../../../model/address-line';

/**
 * Service that handle adress gestion (request / params...)
 */
@Injectable()
export class AddressService {

  /**
   * datas representing finalAddress params and descriptions
   */
  private addressDatas;
  private labels: any;
  public labelsReady: Subject<string>;

  /**
   *
   * @param {StorageService} storageService - here to handle addresses Datas storage
   * @param {TranslateService} translate - handle translation for countrylist (labels are given by back)
   * @param {HttpService} httpService - handle new Address sending
   */
  constructor(private storageService: StorageService, private translate: TranslateService, private httpService: HttpService) {
    this.labelsReady = new Subject<string>();
    this.init();
  }

  /**
   * Handle retrieving info from storage if it's not empty (usefull if Refresh...)
   */
  private init(): void {
    const address = this.storageService.getAddressDatasFromStorage();
    if (address) {
      this.addressDatas = address;
    }
    this.labels = {};
  }
  initLabelsData(): void {
    this.getLabels('fr');
    this.getLabels('en');
  }
  private getLabels(lang: string): void {
    this.httpService.$post(ApiConst.getLabels, {lang: lang}).pipe(map((response) => {
      if (response && response.body && response.body.datas && response.body.datas.labelsJson) {
        this.labels[lang] = response.body.datas.labelsJson;
        this.labelsReady.next(lang);
      }
    })).subscribe();
  }
  /**
   *  address datas (put in storage and in memory)
   *
   * @param {any} toBuild - the data given by Auth Service
   */
  public buildAddressDatas(toBuild: any): void {
    this.storageService.removeAddressDatasFromStorage();
    this.storageService.addAddressDatasInStorage(toBuild);
    this.addressDatas = toBuild;
  }

  /**
   * give the country labels and associate keys
   * @return {Array} - List of labels and keys
   */
  public getCountries(): any[] {

    const currentLangisFR = this.translate.currentLang === 'fr';
    const countries = [];
    for (const property in this.addressDatas) {
      if (this.addressDatas.hasOwnProperty(property)) {
        let label;
        if (currentLangisFR) {
          label = this.addressDatas[property].sCountryLocalName;
        }
        else {
          label = this.addressDatas[property].sCountryIsoName;
        }
        countries.push({label: label, key: property});
      }
    }
    return countries;
  }

  /**
   * give the country various names and associate keys
   * @return {Array} - List of names and keys
   */
  public getCountriesVariousNames(): any[] {
    const countries = [];
    for (const property in this.addressDatas) {
      if (this.addressDatas.hasOwnProperty(property)) {
        const sCountryLocalName = this.addressDatas[property].sCountryLocalName;
        const sCountryIsoName = this.addressDatas[property].sCountryIsoName;
        countries.push({sCountryLocalName: sCountryLocalName, sCountryIsoName: sCountryIsoName, key: property});
      }
    }
    return countries;
  }

  /**
   * return all the properties of a certain country (filtered by key)
   *
   * @param {string} key - the country key
   * @return {any} - the list of properties
   */
  public getPropertiesFromKey(key: string): any {
    return this.addressDatas[key];
  }

  /**
   * function that perform setting finalAddress request
   *
   * @param {AddressLine[]} address - the computed finalAddress
   * @param {string} countryCode - the iso country code of the country
   * @param {number} FoldNumber - the fold serial number
   * @param addressPage
   * @return {Observable<any>} - request results
   */
  public sendAddress(address: AddressLine[], countryCode: string, FoldNumber: number, addressPage: boolean): Observable<any> {

    const dataToSend = JSON.stringify({
      address: this.filterAddress(address),
      country: countryCode,
      serialSent: FoldNumber,
      addressPage: addressPage
    });
    return this.httpService.$post(ApiConst.setNewAddress, dataToSend).pipe(map((response: Response) => {
      return response;
    }));
  }

  /**
   * function that'll filter data to Send for the finalAddress
   * @param {AddressLine[]} lines - list of adresses Lines
   * @return {String[]} -list of usefull datas for request
   */
  private filterAddress(lines: AddressLine[]): string[] {
    const usefullPartOfAddress = [];

    for (const line of lines) {
      usefullPartOfAddress.push(line.sDataValue);
    }

    return usefullPartOfAddress;
  }
  public saveGroupAddress(address: any, countryCode: string, groupId: string): Observable<any> {
    const dataToSend = JSON.stringify({
      address: address,
      country: countryCode,
      groupId: groupId
    });
    return this.httpService.$post(ApiConst.saveGroupAddress, dataToSend).pipe(map((response: Response) => {
      return response.body;
    }));
  }
  public getLabelsForLang(lang: string): any {
    if (this.labels && this.labels[lang]) {
      return this.labels[lang];
    }
    else {
      this.getLabels(lang);
    }
    return null;
  }
  public saveLabelsForCountry(data: any): Observable<any> {
    return this.httpService.$post(ApiConst.saveLabels, data).pipe(map((response) => {
      return response && response.body && response.body.bOK === true;
    }));
  }
}
